import styled from 'styled-components'

export const SectionMapsStyled = styled.section`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: nowrap;
  @media (max-width: 968px) {
    flex-direction: column;
    align-items: center;
  }

`
